import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider, } from 'react-router-dom';
import { TravelClaimList } from './components/travelClaims/TravelClaimList';
import { SignInLoginPasswordForm } from './components/auth/SignInLoginPasswordForm';
import { TravelClaimItem, TravelClaimItemEdit } from './components/travelClaims/TravelClaimItem';
import { SignInPhoneForm } from './components/auth/SignInPhoneForm';
import { TravelClaimModelProvider } from "./context/travelClaims";
import ProtectedRoute from "./components/ProtectedRoute";
import { UserRoles } from "./types/users";
import RoleBasedRedirect from "./components/RoleBasedRedirect";
import { CitiesList } from "./components/cities/CitiesList";
import { CountriesList } from "./components/countries/CountriesList";
import { ShopsList } from "./components/shops/ShopsList";
import { DailyList } from "./components/daily/DailyList";
import { SelectLayout } from "./components/_layout/SelectLayout";
import { ChatProvider } from "./context/chats";
import { PinInput } from './components/auth/PinInput';
import { TryRefreshJWT } from './components/auth/TryRefreshJWT';


const router = createBrowserRouter(
    createRoutesFromElements(
        <Route>

            {/*РЕДИРЕКТ ПО РОЛИ*/}
            <Route path="/" element={<RoleBasedRedirect />} />

            {/*ОБЩИЕ*/}
            <Route
                path='/sign_in/login_password'
                element={
                    <SignInLoginPasswordForm />
                }
            />
            <Route
                path='/sign_in/refresh_token'
                element={
                    <TryRefreshJWT />
                }
            />
            <Route
                path='/sign_in/phone'
                element={
                    <SignInPhoneForm />
                }
            />
            <Route
                path='/sign_in/pin'
                element={
                    <PinInput />
                }
            />
            <Route
                path='/layout'
                element={
                    <SelectLayout />
                }
            />
            {/*МЕНЕДЖЕРСКИЕ*/}
            <Route
                path='/claims'
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            UserRoles.TRAVEL_MANAGER,
                            UserRoles.TRAVEL_ADMIN,
                            UserRoles.SUPER_ADMIN,
                        ]}
                    >
                        <TravelClaimList statusFilter={null} />
                    </ProtectedRoute>
                }
            />
            <Route
                path='/claims/postponed/'
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            UserRoles.TRAVEL_MANAGER,
                            UserRoles.TRAVEL_ADMIN,
                            UserRoles.SUPER_ADMIN,
                        ]}
                    >
                        <TravelClaimList statusFilter={['POSTPONED']} />
                    </ProtectedRoute>
                }
            />
            <Route
                path='/claims/registered/'
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            UserRoles.TRAVEL_MANAGER,
                            UserRoles.TRAVEL_ADMIN,
                            UserRoles.SUPER_ADMIN,
                        ]}
                    >
                        <TravelClaimList statusFilter={['REGISTERED']} />
                    </ProtectedRoute>
                }
            />
            <Route
                path='/claims/in_work/'
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            UserRoles.TRAVEL_MANAGER,
                            UserRoles.TRAVEL_ADMIN,
                            UserRoles.SUPER_ADMIN,
                        ]}
                    >
                        <TravelClaimList statusFilter={['IN_WORK', "REGISTERED"]} />
                    </ProtectedRoute>
                }
            />
            <Route
                path='/claims/finished/'
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            UserRoles.TRAVEL_MANAGER,
                            UserRoles.TRAVEL_ADMIN,
                            UserRoles.SUPER_ADMIN,
                        ]}
                    >
                        <TravelClaimList statusFilter={['FINISHED', 'ISSUED']} />
                    </ProtectedRoute>
                }
            />
            <Route
                path='/claims/:pk/'
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            UserRoles.TRAVEL_MANAGER,
                            UserRoles.TRAVEL_ADMIN,
                            UserRoles.SUPER_ADMIN,
                        ]}
                    >
                        <ChatProvider>
                            <TravelClaimItem />
                        </ChatProvider>
                    </ProtectedRoute>
                }
            />
            <Route
                path='/claims/:pk/edit'
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            UserRoles.TRAVEL_MANAGER,
                            UserRoles.TRAVEL_ADMIN,
                            UserRoles.SUPER_ADMIN,
                        ]}
                    >
                        <TravelClaimModelProvider>
                            <ChatProvider>
                                <TravelClaimItemEdit />
                            </ChatProvider>
                        </TravelClaimModelProvider>
                    </ProtectedRoute>
                }
            />
            {/*АДМИНСКИЕ*/}
            <Route
                path='/daily'
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            UserRoles.SUPER_ADMIN,
                            UserRoles.TRAVEL_ADMIN,
                            UserRoles.APP_ADMIN,
                            UserRoles.TRAVEL_MANAGER,
                        ]}
                    >
                        <DailyList />
                    </ProtectedRoute>
                }
            />
            <Route
                path='/cities'
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            UserRoles.SUPER_ADMIN,
                            UserRoles.TRAVEL_ADMIN,
                            UserRoles.APP_ADMIN,
                            UserRoles.TRAVEL_MANAGER
                        ]}
                    >
                        <CitiesList />
                    </ProtectedRoute>
                }
            />
            <Route
                path='/countries'
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            UserRoles.SUPER_ADMIN,
                            UserRoles.TRAVEL_ADMIN,
                            UserRoles.APP_ADMIN,
                            UserRoles.TRAVEL_MANAGER
                        ]}
                    >
                        <CountriesList />
                    </ProtectedRoute>
                }
            />
            <Route
                path='/shops'
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            UserRoles.SUPER_ADMIN,
                            UserRoles.TRAVEL_ADMIN,
                            UserRoles.APP_ADMIN,
                            UserRoles.TRAVEL_MANAGER
                        ]}
                    >
                        <ShopsList />
                    </ProtectedRoute>
                }
            />
        </Route>
    )
);

export const App = () => {

    return (
        <div className='App'>
            <RouterProvider router={router} />
        </div>
    );
};
